import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { useInlineNotifications } from '../../../../../../hooks'
import { INVOICE_MODAL_PARSING_ERROR_NOTIFICATION } from '../../../../InvoiceModal.constants'

// The floating error toast is added by useInvoiceModal (handleParsingError) —
// this hook only manages the inline banner inside the modal.
export function useInvoiceModalParsingNotifications({ hasParsingError }) {
  const { t } = useTranslation()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  useEffect(() => {
    if (hasParsingError) {
      handleAddNotification({
        id: INVOICE_MODAL_PARSING_ERROR_NOTIFICATION,
        text: t('DocumentMarkAsInvoice.ParsingFailedBannerKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      handleRemoveNotification(INVOICE_MODAL_PARSING_ERROR_NOTIFICATION)
    }
  }, [hasParsingError])

  return {
    notifications,
  }
}
